import { Injectable } from "@angular/core";
import { HttpHandler, HttpInterceptor, HttpRequest, HttpEvent } from "@angular/common/http";
import { LocalStorageRepositoryInterface } from "../local/localstorage.interface";
import { Observable } from "rxjs";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor(private localStorageRepository: LocalStorageRepositoryInterface) {}

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        // const url = req.url;
        const method = req.method;
        let updatedReq;
        if (method === "PUT") {
            updatedReq = req.clone({
                headers: req.headers.set("Content-Type", "application/json")
            });
        } else {
            updatedReq = req.clone();
        }

        const token = this.localStorageRepository.getToken();
        if (token != null && token !== undefined) {
            updatedReq = updatedReq.clone({
                headers: updatedReq.headers.append("Authorization", "Bearer " + token)
            });
            return next.handle(updatedReq);
        }
        return next.handle(updatedReq);
    }
}
